// src/components/layout/menuIcons.tsx
// Centralized menu icons using lucide-react

import {
  Home,
  Users,
  CheckSquare,
  BarChart3,
  MessageSquare,
  Mail,
  Phone,
  MessageCircle,
  Calendar,
  CalendarDays,
  CircleDot,
  UserPlus,
  UsersRound,
  FileText,
  Folder,
  Briefcase,
  Package,
  CreditCard,
  Building2,
  Image,
  UserSearch,
  ShoppingBag,
  Link2,
  Settings,
  type LucideIcon,
} from 'lucide-react';
import type { MenuKey } from '../../types/api';

// Map menu keys to Lucide icons
export const menuIconMap: Record<MenuKey, LucideIcon> = {
  home: Home,
  contacts: Users,
  companies: Building2,
  tasks: CheckSquare,
  pipeline: BarChart3,
  messages: MessageSquare,
  emails: Mail,
  phone: Phone,
  sms: MessageCircle,
  schedule: CalendarDays,
  circles: CircleDot,
  referrals: UserPlus,
  team: UsersRound,
  forms: FileText,
  files: Folder,
  projects: Briefcase,
  offerings: Package,
  payments: CreditCard,
  businessProfile: Building2,
  portfolio: Image,
  recruitment: UserSearch,
  marketplace: ShoppingBag,
  channels: Link2,
  settings: Settings,
};

// Helper to get icon component
export function getMenuIcon(menuKey: MenuKey, className?: string) {
  const IconComponent = menuIconMap[menuKey];
  return <IconComponent className={className || 'w-5 h-5'} />;
}
